// import zhMessages from '../../locales/zh.json';

export default {
  'navbar.lang': 'English',
  'menu.home': '首页',
  'menu.poi': '搜索门店',
  'menu.sftag': '商户打标及取消打标',

  'menu.new': '门店创建',
  'menu.new.newshop': '新增门店',
  'menu.new.new-batch-shop': '批量新增品牌门店',
  'menu.new.virtual-poi': '虚拟门店创建',

  'menu.errors': '门店报错',
  'menu.errors.base-info': '门店基本信息报错',
  'menu.errors.success': '提交成功',
  'menu.errors.shopStatus': '门店营业状态',
  'menu.errors.shopRelations': '门店匹配关系报错',
  'menu.errors.parent': '父子关系报错',
  'menu.errors.batch-parent': '批量父子关系报错',
  'menu.errors.parent-result': '父子关系报错结果',
  'menu.errors.fake-info': '举报虚假商户',
  'menu.errors.multi-fake-info': '批量举报虚假门店',
  'menu.errors.multi-fake-info-download': '批量举报虚假门店文件下载',
  'menu.errors.special-business-time': '批量报错特殊营业时间',
  'menu.errors.BatchBrandShopList': '批量报错品牌门店信息',

  'menu.errors.guide': '路引信息修改',
  'menu.errors.wedding': '婚宴副本报错',

  'menu.errors.repeat': '重复问题报错',
  'menu.errors.repeat.merge': '合并重复门店',
  'menu.errors.repeat.split': '拆分重复门店',
  'menu.errors.repeat.main': '修改主门店',
  'menu.errors.repeat.BatchSplitShop': '批量拆分门店',

  'menu.errors.groups': '连锁关系相关',
  'menu.errors.groups.new-group': '新增连锁门店',
  'menu.errors.groups.remove-group': '解除连锁门店',
  'menu.errors.groups.add-groups': '关联连锁门店',

  'menu.errors.groupon-service': '上门服务报错',

  'menu.errors.multi-parent': '商场父子关系',

  'menu.errors.shop-tag': '标签信息报错',

  'menu.region': '商圈报错',
  'menu.region.region-add': '商圈新增',
  'menu.region.region-update': '商圈删改',
  'menu.region.region-record': '提报记录',

  'menu.info': '信息中心',
  'menu.info.my-report': '我的报错',
  'menu.info.my-todo': '我的待办',
  'menu.info.my-newshops': '我的新增',
  'menu.info.my-groups': '我的连锁',

  'menu.qualification': 'POI 资质',

  'menu.shoplog': '门店日志',
  'menu.shoplog.index': '门店日志',
  'menu.shoplog.download': '门店变更信息下载',

  'menu.operation': '帮助手册',
  'menu.my-abnormalshops': '异常门店管理',

  'app.result.success.title': '提交成功',

  'menu.success': '提交成功',
  'menu.universalPage': '补充材料',

  'app.home.introduce': '介绍',
  'app.analysis.test': '工专路 {no} 号店',
  'app.analysis.introduce': '指标说明',
  'app.analysis.total-sales': '总销售额',
  'app.analysis.day-sales': '日销售额',
  'app.analysis.visits': '访问量',
  'app.analysis.visits-trend': '访问量趋势',
  'app.analysis.visits-ranking': '门店访问量排名',
  'app.analysis.day-visits': '日访问量',
  'app.analysis.week': '周同比',
  'app.analysis.day': '日同比',
  'app.analysis.payments': '支付笔数',
  'app.analysis.conversion-rate': '转化率',
  'app.analysis.operational-effect': '运营活动效果',
  'app.analysis.sales-trend': '销售趋势',
  'app.analysis.sales-ranking': '门店销售额排名',
  'app.analysis.all-year': '全年',
  'app.analysis.all-month': '本月',
  'app.analysis.all-week': '本周',
  'app.analysis.all-day': '今日',
  'app.analysis.search-users': '搜索用户数',
  'app.analysis.per-capita-search': '人均搜索次数',
  'app.analysis.online-top-search': '线上热门搜索',
  'app.analysis.the-proportion-of-sales': '销售额类别占比',
  'app.analysis.channel.all': '全部渠道',
  'app.analysis.channel.online': '线上',
  'app.analysis.channel.stores': '门店',
  'app.analysis.sales': '销售额',
  'app.analysis.traffic': '客流量',
  'app.analysis.table.rank': '排名',
  'app.analysis.table.search-keyword': '搜索关键词',
  'app.analysis.table.users': '用户数',
  'app.analysis.table.weekly-range': '周涨幅',
  'app.settings.menuMap.basic': '基本设置',
  'app.settings.menuMap.security': '安全设置',
  'app.settings.menuMap.binding': '账号绑定',
  'app.settings.menuMap.notification': '新消息通知',
  'app.settings.basic.avatar': '更换头像',
  'app.settings.basic.email': '邮箱',
  'app.settings.basic.email-message': '请输入您的邮箱!',
  'app.settings.basic.nickname': '昵称',
  'app.settings.basic.nickname-message': '请输入您的昵称!',
  'app.settings.basic.profile': '个人简介',
  'app.settings.basic.profile-message': '请输入个人简介!',
  'app.settings.basic.profile-placeholder': '个人简介',
  'app.settings.basic.country': '国家/地区',
  'app.settings.basic.country-message': '请输入您的国家或地区!',
  'app.settings.basic.geographic': '所在省市',
  'app.settings.basic.geographic-message': '请输入您的所在省市!',
  'app.settings.basic.address': '街道地址',
  'app.settings.basic.address-message': '请输入您的街道地址!',
  'app.settings.basic.phone': '联系电话',
  'app.settings.basic.phone-message': '请输入您的联系电话!',
  'app.settings.basic.update': '更新基本信息',
  'app.settings.security.strong': '强',
  'app.settings.security.medium': '中',
  'app.settings.security.weak': '弱',
  'app.settings.security.password': '账户密码',
  'app.settings.security.password-description': '当前密码强度：',
  'app.settings.security.phone': '密保手机',
  'app.settings.security.phone-description': '已绑定手机：',
  'app.settings.security.question': '密保问题',
  'app.settings.security.question-description': '未设置密保问题，密保问题可有效保护账户安全',
  'app.settings.security.email': '备用邮箱',
  'app.settings.security.email-description': '已绑定邮箱：',
  'app.settings.security.mfa': 'MFA 设备',
  'app.settings.security.mfa-description': '未绑定 MFA 设备，绑定后，可以进行二次确认',
  'app.settings.security.modify': '修改',
  'app.settings.security.set': '设置',
  'app.settings.security.bind': '绑定',
  'app.settings.binding.taobao': '绑定淘宝',
  'app.settings.binding.taobao-description': '当前未绑定淘宝账号',
  'app.settings.binding.alipay': '绑定支付宝',
  'app.settings.binding.alipay-description': '当前未绑定支付宝账号',
  'app.settings.binding.dingding': '绑定钉钉',
  'app.settings.binding.dingding-description': '当前未绑定钉钉账号',
  'app.settings.binding.bind': '绑定',
  'app.settings.notification.password': '账户密码',
  'app.settings.notification.password-description': '其他用户的消息将以站内信的形式通知',
  'app.settings.notification.messages': '系统消息',
  'app.settings.notification.messages-description': '系统消息将以站内信的形式通知',
  'app.settings.notification.todo': '账户密码',
  'app.settings.notification.todo-description': '账户密码',
  'app.settings.open': '开',
  'app.settings.close': '关',
  'app.exception.back': '返回首页',
  'app.exception.description.403': '抱歉，你无权访问该页面',
  'app.exception.description.404': '抱歉，你访问的页面不存在',
  'app.exception.description.500': '抱歉，服务器出错了',
  'app.result.error.title': '提交失败',
  'app.result.error.description': '请核对并修改以下信息后，再重新提交。',
  'app.result.error.hint-title': '您提交的内容有如下错误：',
  'app.result.error.hint-text1': '您的账户已被冻结',
  'app.result.error.hint-btn1': '立即解冻',
  'app.result.error.hint-text2': '您的账户还不具备申请资格',
  'app.result.error.hint-btn2': '立即升级',
  'app.result.error.btn-text': '返回修改',

  'app.setting.pagestyle': '整体风格设置',
  'app.setting.pagestyle.dark': '暗色菜单风格',
  'app.setting.pagestyle.light': '亮色菜单风格',
  'app.setting.content-width': '内容区域宽度',
  'app.setting.content-width.fixed': '定宽',
  'app.setting.content-width.fluid': '流式',
  'app.setting.themecolor': '主题色',
  'app.setting.themecolor.dust': '薄暮',
  'app.setting.themecolor.volcano': '火山',
  'app.setting.themecolor.sunset': '日暮',
  'app.setting.themecolor.cyan': '明青',
  'app.setting.themecolor.green': '极光绿',
  'app.setting.themecolor.daybreak': '拂晓蓝（默认）',
  'app.setting.themecolor.geekblue': '极客蓝',
  'app.setting.themecolor.purple': '酱紫',
  'app.setting.navigationmode': '导航模式',
  'app.setting.sidemenu': '侧边菜单布局',
  'app.setting.topmenu': '顶部菜单布局',
  'app.setting.fixedheader': '固定 Header',
  'app.setting.fixedsidebar': '固定侧边菜单',
  'app.setting.fixedsidebar.hint': '侧边菜单布局时可配置',
  'app.setting.hideheader': '下滑时隐藏 Header',
  'app.setting.hideheader.hint': '固定 Header 时可配置',
  'app.setting.othersettings': '其他设置',
  'app.setting.weakmode': '色弱模式',
  'app.setting.copy': '拷贝设置',
  'app.setting.copyinfo': '拷贝成功，请到 src/defaultSettings.js 中替换默认配置',
  'app.setting.production.hint':
    '配置栏只在开发环境用于预览，生产环境不会展现，请拷贝后手动修改配置文件',
};
